import { render, staticRenderFns } from "./KurccFormsPage.vue?vue&type=template&id=5474f6a2&"
import script from "./KurccFormsPage.vue?vue&type=script&lang=js&"
export * from "./KurccFormsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports